import { Component, OnInit, Version } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BubbleItem } from '../../models/domain/bubble.item';
import { AddBubbleRequest } from '../../models/ss-api/requests/add.bubble.request';
import { EditBubbleRequest } from '../../models/ss-api/requests/edit.bubble.request';
import { GetToChargeRequest } from '@models/ss-api/requests/get.to.charge.request';
import { SelectItem } from 'primeng/primeng';
import { BubbleGroupItem, BubbleGroupItemArray } from '@models/domain/bubble.group.item';
import { VersionItemArray } from '@models/domain/version.item';

export interface IPoolStudioBubbleTemplate {
    Title: string;
    Bubble?: BubbleItem;
}

@Component({
    selector: 'poolstudio-bubble-dialog',
    styleUrls: ['./poolstudio.bubble.dialog.scss'],
    templateUrl: './poolstudio.bubble.dialog.html'
})

export class PoolStudioBubbleDialog extends DialogComponent<IPoolStudioBubbleTemplate, boolean> implements IPoolStudioBubbleTemplate, OnInit {
    IsBusy: boolean;
    Title: string;
    Bubble: BubbleItem;

    BubbleForm: FormGroup;

    BubbleGroups: BubbleGroupItemArray;
    SoftwareVersions: VersionItemArray;
    TimeIntervals: Array<string>;

    StartTime: string;
    ExpirationTime: string;

    StartDate: Date;
    ExpirationDate: Date;

    CompleteStartDate: Date;
    CompleteExpirationDate: Date;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }
   

   ngOnInit() {
        this.IsBusy = false;

        if (!this.Bubble) {
            this.Bubble = new BubbleItem();
            this.Bubble.Enabled = true;
            this.Bubble.SortOrder = 0;
            this.Bubble.BubbleGroupID = 1;
            this.Bubble.MinimumSoftwareVersionInt = 0;
            this.Bubble.MaximumSoftwareVersionInt = 0;
        } else {

        }

        console.log("bub", this.Bubble);

        //init Time Variables.  These may be overriden in the routine if we detect a valid existing date
        this.StartTime = "";
        this.ExpirationTime = "";

        //Bind the bubble dates to date variables.  This is how I could get the date pickers to populate empty for
        //DateTime.MinValue values passed from the backend.

        if (this.Bubble.StartDate != undefined){
            let startYear = this.Bubble.StartDate.getFullYear();
            if (startYear != 1){
                this.StartDate = this.Bubble.StartDate;
                let stime = this.StartDate.toLocaleTimeString();
                this.StartTime = stime;
            }
        }

        if (this.Bubble.ExpirationDate != undefined){
            let endYear = this.Bubble.ExpirationDate.getFullYear();
            if (endYear != 1){
                this.ExpirationDate = this.Bubble.ExpirationDate;
                let etime = this.ExpirationDate.toLocaleTimeString();
                this.ExpirationTime = etime;
            }
        }

        

        //if (this.Bubble.StartDate.getFullYear() == 1)
        //    this.Bubble.StartDate = undefined;

        

        this.BubbleForm = new FormGroup({
            'Title': new FormControl(this.Bubble.Title, [Validators.required])
            , 'LinkURL': new FormControl(this.Bubble.LinkURL, [Validators.maxLength(256)])
            , 'Description': new FormControl(this.Bubble.Description)
            , 'Enabled': new FormControl(this.Bubble.Enabled)
            , 'SortOrder': new FormControl(this.Bubble.SortOrder, [Validators.required, Validators.pattern('^-?[0-9 \]+$')])
            , 'StartDate': new FormControl(this.StartDate)
            , 'ExpirationDate': new FormControl(this.ExpirationDate)
            , 'BubbleGroupID': new FormControl(this.Bubble.BubbleGroupID)
            , 'MinimumSoftwareVersionInt': new FormControl(this.Bubble.MinimumSoftwareVersionInt)
            , 'MaximumSoftwareVersionInt': new FormControl(this.Bubble.MaximumSoftwareVersionInt)
            , 'StartTime': new FormControl(this.StartTime)
            , 'ExpirationTime': new FormControl(this.ExpirationTime)

            //'BenchmarkScore': new FormControl(this.CPUBenchmark.BenchmarkScore, [Validators.required, Validators.maxLength(7), Validators.minLength(1), Validators.pattern('^-?[0-9 \]+$')])
        })

        this.InitGroups();
        this.InitVersions();
        this.InitIntervals();
    }

    InitIntervals(){
        this.TimeIntervals = [];
        this.TimeIntervals.push("12:00:00 AM");
        this.TimeIntervals.push("1:00:00 AM");
        this.TimeIntervals.push("2:00:00 AM");
        this.TimeIntervals.push("3:00:00 AM");
        this.TimeIntervals.push("4:00:00 AM");
        this.TimeIntervals.push("5:00:00 AM");
        this.TimeIntervals.push("6:00:00 AM");
        this.TimeIntervals.push("7:00:00 AM");
        this.TimeIntervals.push("8:00:00 AM");
        this.TimeIntervals.push("9:00:00 AM");
        this.TimeIntervals.push("10:00:00 AM");
        this.TimeIntervals.push("11:00:00 AM");
        this.TimeIntervals.push("12:00:00 PM");
        this.TimeIntervals.push("1:00:00 PM");
        this.TimeIntervals.push("2:00:00 PM");
        this.TimeIntervals.push("3:00:00 PM");
        this.TimeIntervals.push("4:00:00 PM");
        this.TimeIntervals.push("5:00:00 PM");
        this.TimeIntervals.push("6:00:00 PM");
        this.TimeIntervals.push("7:00:00 PM");
        this.TimeIntervals.push("8:00:00 PM");
        this.TimeIntervals.push("9:00:00 PM");
        this.TimeIntervals.push("10:00:00 PM");
        this.TimeIntervals.push("11:00:00 PM");

    }

     InitGroups() {
        let disposable = this.api.GetBubbleGroups().subscribe(response => {
            if (response.Result) {
                var bubblegrps = response.Data;
                bubblegrps.forEach((bub) => {
                    switch(bub.Name){
                        case "Info":
                            bub.Name = "Info (Green)";
                            break;
                        case "Warning":
                            bub.Name = "Warning (Yellow)";
                            break;
                        case "Error":
                            bub.Name = "Error (Red)";
                            break;
                        case "Promotion":
                            bub.Name = "Promotion (Blue)";
                            break;
                    }
                });                
                this.BubbleGroups = bubblegrps;
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error Loading Groups',
                    text: response.Message
                }).then(() => { }, () => { });
            }

            disposable.unsubscribe();
        });

    }
   
    InitVersions() {
        let disposable = this.api.GetActiveV3Versions().subscribe(response => {
            if (response.Result) {
                
                var softwareVersions = response.Data;

                var appropriateVersions = new VersionItemArray();
                softwareVersions.forEach((version) => {
                    if (version.VersionInt >= 2024100){
                        appropriateVersions.push(version);
                    }
                });

                // Add extra versions at the beginning of the list
                appropriateVersions.unshift({ VersionInt: 2021100, Name: '2021100' } as any);
                appropriateVersions.unshift({ VersionInt: 2712, Name: '2712' } as any);

                this.SoftwareVersions = appropriateVersions;
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error Loading Versions',
                    text: response.Message
                }).then(() => { }, () => { });
            }

            disposable.unsubscribe();
        });
        
    } 

    confirm() {
        console.log("confirming");
        if (!this.BubbleForm.valid) return false;
        this.IsBusy = true;
        this.result = true;

        let controls = this.BubbleForm.controls;

        //some defaults
        this.CompleteStartDate = null;
        this.CompleteExpirationDate = null;

        if (controls['StartDate'].value != undefined){
            let bareStartDate = new Date(controls['StartDate'].value).toLocaleDateString();
            
            if (controls['StartTime'].value != undefined && controls['StartTime'].value != ""){
                bareStartDate = bareStartDate + " " + controls['StartTime'].value;
            }
            
            this.CompleteStartDate = new Date(bareStartDate);
        }

        if (controls['ExpirationDate'].value != undefined){
            let bareExpirationDate = new Date(controls['ExpirationDate'].value).toLocaleDateString();
            
            if (controls['ExpirationTime'].value != undefined && controls['ExpirationTime'].value != ""){
                bareExpirationDate = bareExpirationDate + " " + controls['ExpirationTime'].value;
            }
            else{
                //we default to 11pm for expiration date - assuming we want to be inclusive of the end date
                bareExpirationDate = bareExpirationDate + " 11:00:00 PM";
            }
            
            console.log("sddd", bareExpirationDate);

            this.CompleteExpirationDate = new Date(bareExpirationDate);

            console.log("ced", this.CompleteExpirationDate);
        }        

        console.log("eddd", controls['ExpirationDate'].value);

        if (!this.Bubble.BubbleItemID) {
            let request: AddBubbleRequest = {
                Title : controls['Title'].value,
                Enabled : controls['Enabled'].value,
                Description : controls['Description'].value,
                LinkURL : controls['LinkURL'].value,
                SortOrder : controls['SortOrder'].value,
                MinimumSoftwareVersionInt : controls['MinimumSoftwareVersionInt'].value,
                MaximumSoftwareVersionInt : controls['MaximumSoftwareVersionInt'].value,
                StartDate : this.CompleteStartDate,
                ExpirationDate : this.CompleteExpirationDate,
                BubbleGroupID : controls['BubbleGroupID'].value
            }

            let disposable = this.api.AddBubble(request).subscribe(response => {
                if (response.Result) {
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'Success!',
                        timer: 1500
                    }).then( () => { this.close(); }, () => { this.close(); } )
                }
                disposable.unsubscribe();
            })
        } else {
            let request: EditBubbleRequest = {
                BubbleID: this.Bubble.BubbleItemID,
                Title : controls['Title'].value,
                Enabled : controls['Enabled'].value,
                Description : controls['Description'].value,
                LinkURL : controls['LinkURL'].value,
                SortOrder : controls['SortOrder'].value,
                MinimumSoftwareVersionInt : controls['MinimumSoftwareVersionInt'].value,
                MaximumSoftwareVersionInt : controls['MaximumSoftwareVersionInt'].value,
                StartDate : this.CompleteStartDate,
                ExpirationDate : this.CompleteExpirationDate,
                BubbleGroupID : controls['BubbleGroupID'].value
            }

            let disposable = this.api.UpdateBubble(request).subscribe(response => {
                if (response.Result) {
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'Success!',
                        timer: 1500
                    }).then( () => { this.close(); }, () => { this.close(); } )
                }
                disposable.unsubscribe();
            })
        }
    }

    Delete() {
        this.sweetAlert.swal({
            type: 'warning',
            title: 'Are you sure?',
            text: 'This action cannot be undone.  Disable instead if you might want to enable this bubble again in the future.',
            showCancelButton: true,
            preConfirm: () => {
                return this.api.DeleteBubble(this.Bubble.BubbleItemID).toPromise()
            }
        }).then(response => {
            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Bubble Deleted',
                    text: 'Deleted successfully without any errors',
                    timer: 1500
                }).then(() => {
                    this.close()
                }, () => {
                    this.close()
                })
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message
                })
            }
        })
    } 

}
